import { render, staticRenderFns } from "./AddressChangeVideos.vue?vue&type=template&id=091c5b62&scoped=true"
import script from "./AddressChangeVideos.vue?vue&type=script&lang=js"
export * from "./AddressChangeVideos.vue?vue&type=script&lang=js"
import style0 from "./AddressChangeVideos.vue?vue&type=style&index=0&id=091c5b62&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091c5b62",
  null
  
)

export default component.exports